import { CompetenciaInput, TextInput } from '@core/components/Inputs';
import RangeDateInput from '@core/components/Inputs/RangeDateInput';
import { SelectInput } from '@core/components/Select';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import SelectCliente from 'app/components/Select/SelectCliente';
import SelectConta from 'app/components/Select/SelectConta';
import { useFormikContext } from 'formik';
import React from 'react';

const onlyNumberRegex = /^\d*$/;

const ContaReceberBuscaAvancadaForm = () => {
  const formik = useFormikContext();
  const _errors = {};

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <CompetenciaInput
          fullWidth
          onBlur={formik.handleBlur}
          id="mesCompetencia"
          label="Mês Competência"
          value={formik.values?.mesCompetencia}
          onChange={formik.handleChange}
          touched={!!_errors.mesCompetencia}
          error={_errors.mesCompetencia}
          helperText={_errors.mesCompetencia}
          format="MM/YYYY"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          id="situacao"
          label="Situação"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.situacao}
          error={_errors?.situacao}
          touched={!!_errors?.situacao}
          options={[
            { id: 'ABERTA', title: 'Aberta' },
            { id: 'BAIXADA', title: 'Baixada' },
            { id: 'PARCIAL', title: 'Parcial' },
            { id: 'EXCLUIDA', title: 'Excluída' },
            { id: 'TODAS', title: 'Todas' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCliente
          id="cliente"
          name="cliente"
          label="Cliente"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.cliente}
          touched={!!_errors.cliente}
          error={_errors.cliente}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCategoria
          id="categoria"
          label="Categoria"
          value={formik.values?.categoria}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={100}
          natureza="RECEITA"
          touched={!!_errors.categoria}
          error={_errors.categoria}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataVencimento"
          name="dataVencimento"
          value={[formik.values.dataVencimentoInicio, formik.values.dataVencimentoFim]}
          label="Período de vencimento"
          error={!!_errors.dataVencimento}
          helperText={_errors.dataVencimento}
          onBlur={formik.handleBlur}
          onChange={(inicio, fim) => {
            formik.setFieldValue('dataVencimentoFim', fim);
            formik.setFieldValue('dataVencimentoInicio', inicio);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataRecebimento"
          name="dataRecebimento"
          value={[formik.values.dataRecebimentoInicio, formik.values.dataRecebimentoFim]}
          label="Período de recebimento"
          error={!!_errors.dataRecebimento}
          helperText={_errors.dataRecebimento}
          onBlur={formik.handleBlur}
          onChange={(inicio, fim) => {
            formik.setFieldValue('dataRecebimentoFim', fim);
            formik.setFieldValue('dataRecebimentoInicio', inicio);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataLiquidacao"
          name="dataLiquidacao"
          value={[formik.values.dataLiquidacaoInicio, formik.values.dataLiquidacaoFim]}
          label="Período de liquidação"
          error={!!_errors.dataLiquidacao}
          helperText={_errors.dataLiquidacao}
          onBlur={formik.handleBlur}
          onChange={(inicio, fim) => {
            formik.setFieldValue('dataLiquidacaoFim', fim);
            formik.setFieldValue('dataLiquidacaoInicio', inicio);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataEmissao"
          name="dataEmissao"
          value={[formik.values.dataEmissaoInicio, formik.values.dataEmissaoFim]}
          label="Período de emissão"
          error={!!_errors.dataEmissao}
          helperText={_errors.dataEmissao}
          onBlur={formik.handleBlur}
          onChange={(inicio, fim) => {
            formik.setFieldValue('dataEmissaoFim', fim);
            formik.setFieldValue('dataEmissaoInicio', inicio);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <InputMonetario
          fullWidth
          id="valorBruto"
          label="Valor (R$)"
          handleBlur={formik.handleBlur}
          value={formik.values?.valorBruto}
          touched={!!_errors.valorBruto}
          error={_errors.valorBruto}
          handleChange={formik.handleChange}
          helperText={_errors.valorBruto}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="nossoNumero"
          label="Nosso número"
          fullWidth
          value={formik.values?.nossoNumero}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={20}
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectConta
          id="conta"
          name="conta"
          label="Conta"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.conta}
          touched={!!_errors?.conta}
          error={_errors?.conta}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          id="origemLancamento"
          label="Origem do lançamento"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.origemLancamento}
          error={_errors?.origemLancamento}
          touched={!!_errors?.origemLancamento}
          options={[
            { id: 'CONTRATO', title: 'Contratos' },
            { id: 'VENDA', title: 'Vendas' },
            { id: 'VENDA_CONTRATO', title: 'Venda e contrato' },
            { id: 'CONTA_RECEBER', title: 'Contas receber' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="documentoFiscal"
          label="Número do documento fiscal"
          fullWidth
          value={formik.values?.documentoFiscal}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={30}
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="apenasRegulares"
              name="apenasRegulares"
              value={formik.values?.apenasRegulares}
              checked={formik.values.apenasRegulares}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          }
          label="Buscar somente receitas regulares"
        />
      </Grid>
    </Grid>
  );
};

export default ContaReceberBuscaAvancadaForm;
